import SignupModule from './Signup.module';

export { default as SignupModule }
  from './Signup.module';

export default SignupModule;
